import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { path } from 'ramda';

import { defaultProjectMassListFilters } from 'constants/defaultFilters';
import DropdownStatusFilter from 'components/common/controls/DropdownStatusFilter';
import RefreshButton from 'components/common/controls/RefreshButton';
import { openModalProjectMassSettings } from 'actions/modalActions';
import { getUser } from 'actions/asyncActions';
import ProjectMassListUserFilter from './controls/ProjectMassListUserFilter';
import CustomIcon from 'components/common/CustomIcon';

const stateToProps = state => ({
    user: getUser.selectData(state),
});

@connect(stateToProps, { openModalProjectMassSettings })
export default class ProjectMassListControls extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        filters: PropTypes.object.isRequired,
        refreshMeta: PropTypes.object.isRequired,
        handleRefresh: PropTypes.func.isRequired,
        handleFilters: PropTypes.func.isRequired,
        openModalProjectMassSettings: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired
    };

    render() {
        const { id, user: { id: userId, permissions }, filters, refreshMeta, handleRefresh, handleFilters, openModalProjectMassSettings } = this.props;

        return (
            <div className="ant-row">
                <Col span={8}>
                    <ProjectMassListUserFilter userId={id || userId} disabled={!path(['web', 'userFilter'], permissions)} />
                </Col>
                <Col span={16} className="text-right icon-bar">
                    <DropdownStatusFilter
                        filters={filters}
                        defaultFilters={defaultProjectMassListFilters}
                        translation='filterStatus.projectMass.'
                        onFiltersChange={handleFilters}
                    />
                    <a onClick={() => openModalProjectMassSettings()}>
                        <CustomIcon type="settings" />
                    </a>
                    <RefreshButton refreshMeta={refreshMeta} handleRefresh={handleRefresh} />
                </Col>
            </div>
        );
    }
}
